<template>
  <footer class="d-flex flex-column align-items-center">
    <address class="author">
      <router-link
        :to="`/${author.username}/`"
        :target="newWindow ? '_blank' : null"
        rel="author"
        v-if="author.username"
      >
        <figure>
          <img
            :src="`${author.cropped_avatar}?width=156`"
            class="rounded-circle"
            v-if="author.cropped_avatar"
          />
          <img src="../assets/avatar.png" v-else />
        </figure>
        <p
          class="name display-1 text-center text-uppercase font-weight-bold"
          :class="variant"
        >
          {{ author && author.name ? author.name : "&nbsp;" }}
        </p>
      </router-link>
      <router-link
        to=""
        class="disabled"
        :target="newWindow ? '_blank' : null"
        rel="author"
        v-else
      >
        <figure>
          <img src="../assets/avatar.png" />
        </figure>
        <p
          class="name display-1 text-center text-uppercase font-weight-bold"
          :class="variant"
        >
          &nbsp;
        </p>
      </router-link>
      <p class="category display-3 text-center">
        <category
          :categories="author.categories"
          :variant="variant"
          :new-window="newWindow"
        />
      </p>
    </address>
  </footer>
</template>

<script>
import Vue from "vue";
import Category from "./Category";

export default Vue.component("author", {
  components: {
    Category
  },
  props: {
    author: Object,
    variant: {
      type: String,
      default: "light"
    },
    newWindow: {
      type: Boolean,
      default: false
    }
  }
});
</script>

<style lang="scss" scoped>
.author {
  margin: 0;

  figure {
    text-align: center;
    margin-bottom: 10px;

    img {
      width: 78px;
    }
  }

  a {
    &.disabled {
      text-decoration: none;
      pointer-events: none;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  p {
    margin: 0;
  }

  .name.light {
    color: rgb(72, 72, 72);
  }

  .name.dark {
    color: white;
  }
}
</style>
